import * as H from 'history';
import * as React from 'react';
import { Dashboard } from 'app/area/dashboard/dashboard';
import styles from './dashboard.scss';

interface DashboardRouteProps {
  location: H.Location;
  params: { favouriteId?: string, dashboardType?: string };
}

export function DashboardRoute({
  location,
  params
}: DashboardRouteProps) {
  return (
    <div className={styles.dashboardView}>
      <Dashboard
        dashboardType={parseInt(params.dashboardType, 10)}
        requestedMainFavouriteId={parseInt(params.favouriteId, 10)}
        showDescription={true}
        location={location} />
    </div>
  );
}
